import serialize from './serialize';

const RenderContent = ({ content, component, sx }) => {
  if (!content) return null;
  return serialize(content, component, sx);
};

export default RenderContent;
